import React from 'react'
import { Card, CardActionArea, CardContent, CardMedia, Chip, Stack, Typography, Box } from '@mui/material'

export type Video = {
    id: string
    title: string
    thumbnailUrl: string
    duration?: string
    tags?: string[]
    series?: string
}

type VideoCardProps = {
    video: Video
    onClick?: (id: string) => void
}

const VideoCard: React.FC<VideoCardProps> = ({ video, onClick }) => {
    return (
        <Card elevation={3} sx={{ borderRadius: 2, transition: 'transform 180ms ease, box-shadow 180ms ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 8 } }}>
            <CardActionArea onClick={() => onClick?.(video.id)}>
                <Box sx={{ position: 'relative' }}>
                    <CardMedia component="img" height="180" image={video.thumbnailUrl} alt={video.title} />
                    {video.duration && (
                        <Box sx={{ position: 'absolute', bottom: 8, right: 8, bgcolor: 'rgba(0,0,0,0.75)', color: 'white', px: 0.75, py: 0.25, borderRadius: 1, fontSize: 12 }}>
                            {video.duration}
                        </Box>
                    )}
                </Box>
                <CardContent>
                    <Typography variant="subtitle1" gutterBottom noWrap title={video.title}>
                        {video.title}
                    </Typography>
                    {video.tags && video.tags.length > 0 && (
                        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                            {video.tags.slice(0, 3).map((t) => (
                                <Chip key={t} label={t} size="small" variant="outlined" />
                            ))}
                        </Stack>
                    )}
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

export default VideoCard


